import React from 'react';
import { useTranslation } from 'react-i18next';

import { combineClassNames } from '@common/utils/combineClassNames';
import { FormIcon } from '@modules/forms/components/form-icon';
import Icon from '@common/components/icon';

import './form-list-item.scss';

export type FormShortcut = {
  id: string;
  title?: string;
  name?: string;
  color: string;
  icon: string;
};

type OwnProps = {
  item: FormShortcut;
  selectedForm: FormShortcut | null;
  setSelectedForm: (selectedForm: FormShortcut | null) => void;
};

const FormListItem = ({ item, selectedForm, setSelectedForm }: OwnProps) => {
  const { t } = useTranslation();

  const selected = item.id === selectedForm?.id;
  const fullClassName = combineClassNames('FormShortcutListItem', {
    'FormShortcutListItem--selected': selected,
  });

  return (
    <div
      role="option"
      className={fullClassName}
      onClick={() => {
        if (selectedForm?.id === item.id) {
          setSelectedForm(null);
        } else {
          setSelectedForm(item);
        }
      }}
    >
      <FormIcon form={item} />
      <span>
        { item.title || <small>{t('forms:form_item_no_title')}</small> }
      </span>
      { selected && <Icon type="check" /> }
    </div>
  );
};

export default FormListItem;
